<template>
	<section class="container page-content">
		<div class="row">
			<div class="col-xs-12 col-sm-8">
				<h1>Advanced Search</h1>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12 col-sm-8">
				<div class="form-group">
					<div class="form-group">
						<label class="form-label">Search project title or client</label>
						<input
							v-model="searchTerm"
							type="text"
							class="form-control"
							placeholder="Search"
						/>
					</div>
					<template v-if="regions && regions.length > 0">
						<div class="form-group">
							<label class="form-label">Countries</label>
							<b-multi-select
								v-model="selectedRegions"
								:options="regions"
								class="multi-select"
								placeholder="Select country"
								filterable
								block
							/>
						</div>
					</template>
					<template v-if="tags && tags.length > 0">
						<div class="form-group">
							<label class="form-label">Tags</label>
							<b-multi-select
								v-model="selectedTags"
								:options="tags"
								class="multi-select"
								placeholder="Select tag"
								filterable
								block
							/>
						</div>
					</template>
					<template>
						<div class="form-group">
							<label class="form-label" for="FilterYear">Date from</label>
							<input
								v-model="selectedFilters.dateFrom"
								filterable
								block
								collapse-selected
								type="date" id="date-1" class="form-control ">
						</div>
					</template>
					<template>
						<div class="form-group">
							<label class="form-label" for="FilterYear">Date to</label>
							<input
								v-model="selectedFilters.dateTo"
								filterable
								block
								collapse-selected
								type="date" id="date-2" class="form-control ">
						</div>
					</template>
				</div>
				<div class="row" style="margin-top:60px;">
					<div class="col-xs-12 col-sm-6">
						<b-btn type="default" style="margin-bottom:15px;" @click="reset"
							>Reset</b-btn
						>
					</div>
					<div class="col-xs-12 col-sm-6">
						<b-btn
							type="primary"
							class="btn-lg btn-block btn-success"
							@click="search"
							>Search</b-btn
						>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="less" scoped>
.form-group {
	padding-bottom: 15px;
}
</style>

<script>
import { map, flow, filter, orderBy } from 'lodash/fp';

export default {
	created() {
		this.getRegulationFilterOptions();
	},
	data() {
		return {
			searchTerm: null,
			clients: [],
			status: [],
			regions: [],
			dates: [],
			tags: [],
			selectedClients: [],
			selectedRegions: [],
			selectedStatus: [],
			selectedDates: [],
			selectedTags: [],
			dateFrom: '',
			dateTo: '',
		};
	},
	computed: {
		selectedFilters() {
			return {
				clients: this.selectedClients,
				regions: this.selectedRegions,
				status: this.selectedStatus,
				dates: this.selectedDates,
				tags: this.selectedTags,
			};
		},
	},
	methods: {
		async getRegulationFilterOptions() {
			const {
				data: { data: options },
			} = await this.$axios.get('/resource/filter-options');

			const formattedClients = flow(
				map(({ id, name }) => ({
					value: id,
					label: name,
				})),
				orderBy('label', 'asc')
			)(options.filterOptions.clients);

			const formattedStatus = map(
				({ id, name }) => ({
					value: id,
					label: name,
				}),
				options.filterOptions.status
			);

			const formattedDates = flow(
				filter(value => value !== 'Invalid date'),
				map(value => ({ value, label: value }))
			)(options.filterOptions.dates);

			const formattedTags = map(
				({ id, name }) => ({
					value: id,
					label: name,
				}),
				options.filterOptions.tags
			);

			const formattedRegions = map(
				({ id, name }) => ({
					value: id,
					label: name,
				}),
				options.filterOptions.regions
			);

			this.$set(this, 'clients', formattedClients);
			this.$set(this, 'regions', formattedRegions);
			this.$set(this, 'status', formattedStatus);
			this.$set(this, 'dates', formattedDates);
			this.$set(this, 'tags', formattedTags);
		},
		reset() {
			this.searchTerm = null;
			this.selectedClients = [];
			this.selectedRegions = [];
			this.selectedStatus = [];
			this.selectedDates = [];
			this.selectedTags = [];
			this.dateTo = '';
			this.dateFrom = '';
		},
		search() {
			this.$router.push({
				path: '/projects',
				query: {
					searchTerm: this.searchTerm,
					selectedFilters: this.selectedFilters,
				},
			});
		},
	},
};
</script>
